﻿import $ from "jquery";
import staticMicrosite from "./microsite.static";
import InlineMicrosite from "./microsite.inline";
import listener from "./bannerListener";

var browsers = {
	ie: "msie",
	chrome: "chrome",
	opera: "opera",
	safari: "safari",
	mozilla: "mozilla"
};

var postMessages = {
	openMicrositeRequest: "openMicrositeRequest"
};

var bannerContentType = {
	html: "html",
	image: "image"
};

var defaults = {
	campaignData: {
		fallbackEvent: "from server",
		imageBanner: {
			id: "from server",
			url: "from server",
			width: "from server",
			height: "from server",
			type: "from server",
			onClickLogEvent: "from server"
		},
		htmlBanner: {
			id: "from server",
			url: "from server",
			width: "from server",
			height: "from server",
			type: "from server",
			onClickLogEvent: "from server",
			domain: "from server"
		},
		microsite: {
			url: "from server",
			displayMode: "from-server",
			width: "from server",
			height: "from server"
		}
	}
};

function parseEvent(eventJson) {
	if (!eventJson)
		return null;

	return $.parseJSON(eventJson);
}

function dispatchEvent(logEvent) {
	if (!logEvent)
		return;

	var eventData = parseEvent(logEvent);

	if (!eventData)
		return;

	var logFunction = window[eventData.logFunctionName];

	if (!logFunction)
		return;

	logFunction(eventData.eventId);
}

function getBannerById(id) {
	return $.grep(
		ccsCampaignBanner.registeredBanners,
		function (item) { return item.id && item.id === id; })[0];
}

function onBannerClick(bannerId) {
	const banner = getBannerById(bannerId);

	dispatchEvent(banner.onClickLogEvent);

	const microsite = banner.microsite;
	if (microsite.url == undefined) {
		let $content = $(`#ic${bannerId}`);

		if ($content.length === 0) {
			const inlineMicrosite = new InlineMicrosite(microsite, bannerId);
			$content = $(`#ic${bannerId}`);
			$content.data("microsite", inlineMicrosite);
		}

		$content.data("microsite").show();
	} else {
		staticMicrosite(microsite, bannerId);
	}
}

function registerBanner(banner) {
	if (!banner && !banner.id)
		return;

	if (getBannerById(banner.id))
		return;

	ccsCampaignBanner.registeredBanners.push(banner);
}

function getCurrentBrowser() {
	var ua = navigator.userAgent;

	ua = ua.toLowerCase();

	var match = /(chrome)[ \/]([\w.]+)/.exec(ua) ||
		/(webkit)[ \/]([\w.]+)/.exec(ua) ||
		/(opera)(?:.*version|)[ \/]([\w.]+)/.exec(ua) ||
		/(msie) ([\w.]+)/.exec(ua) ||
		ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua) ||
		[];

	var matched = {
		browser: match[1] || "",
		version: match[2] || "0"
	};

	var browser = {};

	if (matched.browser) {
		// Chrome is Webkit, but Webkit is also Safari.
		if (matched.browser !== browsers.chrome && matched.browser === "webkit") {
			browser.name = browsers.safari;
			browser.version = matched.version;
		} else {
			browser.name = matched.browser;
			browser.version = matched.version;
		}
	}

	return browser;
};

function isCompatibleBrowser() {
	var currentBrowser = getCurrentBrowser();

	var uncompatibleBrowsers = [
		{ name: browsers.ie, version: "9.0" },
		{ name: browsers.ie, version: "8.0" },
		{ name: browsers.ie, version: "7.0" },
		{ name: browsers.ie, version: "6.0" },
		{ name: browsers.ie, version: "5.0" }
	];

	var findedUncompatibleBrowsers = $.grep(uncompatibleBrowsers,
		function (item) {
			return item.name === currentBrowser.name && item.version === currentBrowser.version;
		});

	return findedUncompatibleBrowsers.length === 0;
}

function selectBanner(campaignData) {
	var isCompatible = isCompatibleBrowser();

	if (!isCompatible)
		dispatchEvent(campaignData.fallbackEvent);

	return isCompatible
		? campaignData.htmlBanner || campaignData.imageBanner
		: campaignData.imageBanner || campaignData.htmlBanner;
}

function buildCampaignBanner(banner, icData) {
	var $bannerContainer = $("#" + banner.id);

	$bannerContainer.data("ic", icData);

	if (banner.type === bannerContentType.html) {
		$bannerContainer.css({
			height: banner.height + "px",
			maxWidth: banner.width + "px"
		});

		var $bannerIframe = $("<iframe scrolling=\"no\" frameBorder=\"0\"></iframe>")
			.attr("src", banner.url)
			/*CSS hack for mobile safari since it ignores the width and height of iframe*/
			.css({
				width: "1px",
				minWidth: "100%",
				height: "1px",
				minHeight: "100%"
			});

		$bannerContainer.append($bannerIframe);

		listener.addTrustedDomain(banner.domain);
		listener.registerHandler(banner.id, postMessages.openMicrositeRequest, onBannerClick);
	}

	if (banner.type === bannerContentType.image) {

		var $bannerLink = $("<a style=\"cursor: pointer;\"></a>");
		var $bannerImgContent = $("<img src=\"" + banner.url + "\" alt=\"\" style=\"border: 0;\" />");
		$bannerLink.append($bannerImgContent);
		$bannerContainer.append($bannerLink);

		$bannerLink.click(function () {
			onBannerClick(banner.id);
		});
	}
}

export default function ccsCampaignBanner(options) {
	var o = $.extend(true, {}, defaults, options);

	var selectedBanner = selectBanner(o.campaignData);

	if (!selectedBanner)
		return;

	registerBanner(selectedBanner);
	buildCampaignBanner(selectedBanner, o.inlineContent);
}

ccsCampaignBanner.registeredBanners = [];
window.ccsCampaignBanner = window.ccsCampaignBanner || ccsCampaignBanner;
